import React from "react";

const ListProperty = ({
  active,
  width = 20,
  height = 20,
}: {
  active?: boolean;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="13 12.5 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.3016 31.1015H16.7016C16.4629 31.1015 16.2339 31.0067 16.0652 30.8379C15.8964 30.6691 15.8016 30.4402 15.8016 30.2015V22.1015H13.1016L22.3959 13.6523C22.5616 13.5015 22.7775 13.418 23.0016 13.418C23.2256 13.418 23.4416 13.5015 23.6073 13.6523L32.9016 22.1015H30.2016V30.2015C30.2016 30.4402 30.1067 30.6691 29.938 30.8379C29.7692 31.0067 29.5403 31.1015 29.3016 31.1015ZM17.6016 29.3015H28.4016V20.4428L23.0016 15.5342L17.6016 20.4428V29.3015ZM20.3016 21.2015H25.7016V26.6015H20.3016V21.2015ZM22.1016 23.0015V24.8015H23.9016V23.0015H22.1016Z"
        fill={` ${active ? "#2D96A7" : "#868C98"} `}
      />
    </svg>
  );
};

export default ListProperty;
